/** Helper type for Expo Router's query param values. Repeated params (`?x=a&x=b`) arrive as an array */
export type QueryParam = string | string[];

/**
 * Narrows a query param to a single value, taking the first of a repeated param
 * Expo Router supports repeated params, but almost all params are individual strings
 */
export const firstQueryParam = (
  value: QueryParam | undefined,
): string | undefined => (Array.isArray(value) ? value[0] : value);
